import React from "react";

const AnimationCommon = () => {
  return (
    <div className="review-animation">
      <div className='animation-circle absolute'>
        <i></i>
        <i></i>
        <i></i>
      </div>
      <div className='animation-circle-inverse'>
        <i></i>
        <i></i>
        <i></i>
      </div>
    </div>
  );
};

export default AnimationCommon;
